

export const API = {

    //dashboard
    dashboard: `/api/machines/dashboard-status`,

    getMachine: "/api/machines/all",
    createMachine: "/api/machines/create",
    updateMachine: "/api/machines/update",
    deleteMachine: "/api/machines/delete",

    //mahcine statuss
    getMachineStatus: "/api/telemetry/getAdminDashboardData",

    //slots

    getSlots: (id) => `/api/slots/machine/${id}`,
    createSlots: `/api/slots/create/`,
    deleteSlot: (id) => `/api/slots/delete`,
    updateSlot: (id) => `/api/slots/update`,

    //Category
    getCategory: "/api/category/all",
    createCategory: "/api/category/create",
    updateCategory: "/api/category/update",
    deleteCategory: (id) => `/api/category/delete/${id}`,

    //Product
    getProduct: "/api/products/all",
    getProductWithDetails: (id) => `/api/products/productswithplacements/${id}`,
    createProduct: "/api/products/create",
    updateProduct: (id) => `/api/products/update/${id}`,
    deleteProduct: "/api/products/delete",

    // Videos
    createVideo: "/api/videos/create",
    getVideos: "/api/videos/all",
    updateVideo: (id) => `/api/videos/update/${id}`,
    deleteVideo: (id) => `/api/videos/delete/${id}`,
    removeMachineFromVideo: (id) => `/api/videos/remove-machine/${id}`,


    getTransactions: "/api/transection/admin/transactions",
    updateTransaction: "/api/transection/admin/transactions",

    getExchangeRate:"/api/v1/admin/auth/getExchangeRate",

    //Alerts
    stockAlert: "/api/products/stockAlert",
    markAlertRead: (id) => `/api/products/stockAlert/${id}/read`,

    //Auth
    sendOtp: "/api/v1/admin/auth/forgetPassword",
    forgetPassword: "/api/v1/admin/auth/forgetPassword",
    changePassword: "/api/v1/admin/auth/changePassword",

}
